<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.5" y="1.5" width="5" height="5" stroke="currentColor"/>
<rect x="1.5" y="9.5" width="5" height="5" stroke="currentColor"/>
<rect x="9.5" y="9.5" width="5" height="5" stroke="currentColor"/>
<rect x="9.5" y="1.5" width="5" height="5" stroke="currentColor"/>
</svg>
